<div class="svg-editor position-relative w-100 h-100 mt-1">
  <div id="method-draw" class="app">
    <div id="rulers">
      <div id="ruler_corner"></div>
      <div id="ruler_x"></div>
      <div id="ruler_y"></div>
    </div>

    <div id="workarea">
      <div id="svgcanvas"></div>
    </div>

    <div id="menu_bar">
      <a class="menu d-none">
        <div class="menu_title" id="logo">
          <svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M-.1 16.1L16 .04V16.1H-.1z"></path>
            <path d="M0 16.1V.1l16 16H0z" fill="var(--z7)"></path>
          </svg>
        </div>
        <div class="menu_list inverted-undo">
          <div id="modal_about" class="menu_item" data-action="about">About this app...</div>
          <div class="separator"></div>
          <div id="modal_preferences" class="menu_item" data-action="configure">Configure...</div>
          <div id="modal_shortcuts" class="menu_item" data-action="shortcuts">Keyboard Shortcuts...</div>
          <div id="modal_donate" class="menu_item" data-action="donate">Donate or sponsor...</div>
        </div>
      </a>

      <div class="menu">
        <div class="menu_title">File</div>
        <div class="menu_list inverted-undo" id="file_menu">
          <div data-action="clear" id="tool_clear" class="menu_item d-none">New Document</div>

          <div id="tool_open" class="menu_item d-none">
            <input type="file" accept="image/svg+xml" id="tool_open_input" />
            Open SVG... <span class="shortcut d-none">⌘O</span>
          </div>

          <div id="tool_import" class="menu_item">
            <input id="tool_import_input" type="file" accept="image/*" />
            Place Image
            <span class="shortcut d-none">⌘K</span>
          </div>
          <div class="menu_item" (click)="saveSvg()">Save Label Template<span class="shortcut">⌘S</span></div>
          <div data-action="save" id="tool_save" class="menu_item">Download Template</div>
          <div data-action="export" id="tool_export" class="menu_item d-none">Export as PNG</div>
          <div class="menu_item" (click)="navigateToLabelTemplateDetails()">Exit</div>
        </div>
      </div>

      <div class="menu">
        <div class="menu_title">Edit</div>
        <div class="menu_list inverted-undo" id="edit_menu">
          <div data-action="undo" class="menu_item" id="tool_undo">Undo <span class="shortcut">⌘Z</span></div>
          <div data-action="redo" class="menu_item" id="tool_redo">Redo <span class="shortcut">⌘Y</span></div>
          <div class="separator"></div>
          <div data-action="cutSelected" class="menu_item action_selected disabled" id="tool_cut">Cut <span class="shortcut">⌘X</span></div>
          <div data-action="copySelected" class="menu_item action_selected disabled" id="tool_copy">Copy <span class="shortcut">⌘C</span></div>
          <div data-action="pasteSelected" class="menu_item action_selected disabled" id="tool_paste">Paste <span class="shortcut">⌘V</span></div>
          <div data-action="duplicateSelected" class="menu_item action_selected disabled" id="tool_clone">Duplicate <span class="shortcut">⌘D</span></div>
          <div data-action="deleteSelected" class="menu_item action_selected disabled" id="tool_delete">Delete <span>⌫</span></div>
        </div>
      </div>

      <div class="menu">
        <div class="menu_title">Object</div>
        <div class="menu_list inverted-undo" id="object_menu">
          <div class="menu_item action_selected disabled" id="tool_move_top">Bring to Front</div>
          <div class="menu_item action_selected disabled" id="tool_move_up">Bring Forward</div>
          <div class="menu_item action_selected disabled" id="tool_move_down">Send Backward</div>
          <div class="menu_item action_selected disabled" id="tool_move_bottom">Send to Back</div>
          <div class="separator"></div>
          <div class="menu_item action_multi_selected disabled" id="tool_group">Group Elements</div>
          <div class="menu_item action_group_selected disabled" id="tool_ungroup">Ungroup Elements</div>
          <div class="separator d-none"></div>
          <div class="menu_item action_path_convert_selected disabled d-none" id="tool_topath">Convert to Path</div>
          <div class="menu_item action_path_selected disabled d-none" id="tool_reorient">Reorient path</div>
        </div>
      </div>

      <div class="menu">
        <div class="menu_title">View</div>
        <div class="menu_list inverted-undo" id="view_menu">
          <div class="menu_item push_button_pressed" id="tool_rulers">View Rulers</div>
          <div class="menu_item" id="tool_wireframe">View Wireframe</div>
          <div class="separator d-none"></div>
          <div class="menu_item d-none" id="tool_source" data-action="source">Source...</div>
        </div>
        <div class="separator"></div>
      </div>
      <div class="menu-right">
        <button class="menu-icon" id="darkmode-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path
              d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <div id="panels" class="tools_panel">
      <input type="text" [(ngModel)]="selectedElementId" (blur)="renameSelectedElement()" placeholder="Please select element" id="idInputElement" class="element-id-control" />
      <div id="canvas_panel" class="context_panel">
        <h4>Canvas</h4>

        <div class="draginputs">
          <label class="draginput twocol textcontent" data-title="Change Content">
            <input id="canvas_title" type="text" />
            <span>Title</span>
          </label>

          <label data-title="Change canvas width" class="draginput">
            <input id="canvas_width" type="number" pattern="[0-9]*" value="800" min="0" max="10000" />
            <span class="icon_label">Width</span>
          </label>

          <label data-title="Change canvas height" class="draginput">
            <input id="canvas_height" type="number" pattern="[0-9]*" value="600" min="0" max="10000" />
            <span class="icon_label">Height</span>
          </label>

          <label data-title="Change canvas color" class="draginput" style="visibility: hidden">
            <span>Color</span>
            <div id="color_canvas_tools">
              <div class="color_tool active" id="tool_canvas">
                <div class="color_block">
                  <div id="canvas_bg"></div>
                  <div id="canvas_color"></div>
                </div>
              </div>
            </div>
          </label>

          <div class="draginput">
            <span>Sizes</span>
            <select id="resolution">
              <option id="selectedPredefined" selected="selected">Custom</option>
              <option id="fitToContent" value="content">Fit to Content</option>

              <optgroup label="A Label">
                <option value="105x75">105 x 75</option>
                <option value="50x50">50 x 50</option>
                <option value="60x35">60 x 35</option>
              </optgroup>

              <optgroup label="K Label">
                <option value="105x75">105 x 75</option>
                <option value="60x35">60 x 35</option>
                <option value="80x80">80 x 80</option>
              </optgroup>

              <optgroup label="T Label">
                <option value="30x15">30 x 15</option>
                <option value="30x9 ">30 x 9</option>
                <option value="36x16">36 x 16</option>
                <option value="40x30">40 x 30</option>
                <option value="45x25">45 x 25</option>
                <option value="50x14">50 x 14</option>
                <option value="50x9 ">50 x 9</option>
                <option value="80x15">80 x 15</option>
              </optgroup>

              <optgroup label="Z Label">
                <option value="12x9">12 x 9</option>
                <option value="30x15">30 x 15</option>
                <option value="30x9">30 x 9</option>
                <option value="36x16">36 x 16</option>
                <option value="45x25">45 x 25</option>
                <option value="4x17">4 x 17</option>
                <option value="50x14">50 x 14</option>
                <option value="50x9">50 x 9</option>
                <option value="60x35">60 x 35</option>
              </optgroup>
            </select>
            <div class="caret"></div>
            <label id="resolution_label">Custom</label>
          </div>
        </div>
      </div>

      <div id="rect_panel" class="context_panel">
        <h4>Rectangle</h4>
        <div class="draginputs">
          <label class="draginput">
            <input type="number" id="rect_x" class="attr_changer" data-title="Change X coordinate" data-attr="x" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label class="draginput">
            <input type="number" id="rect_y" class="attr_changer" data-title="Change Y coordinate" data-attr="y" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
          <label class="draginput" id="rect_width_tool attr_changer" data-title="Change rectangle width">
            <input id="rect_width" class="attr_changer" data-attr="width" type="number" pattern="[0-9]*" min="0" max="10000" />
            <span class="icon_label">Width</span>
          </label>
          <label class="draginput" id="rect_height_tool" data-title="Change rectangle height">
            <input id="rect_height" class="attr_changer" data-attr="height" type="number" pattern="[0-9]*" min="0" max="10000" />
            <span class="icon_label">Height</span>
          </label>
        </div>
      </div>

      <div id="path_panel" class="context_panel clearfix">
        <h4>Path</h4>
        <div class="draginputs">
          <label>
            <input type="number" id="path_x" class="attr_changer" data-title="Change ellipse's cx coordinate" data-attr="x" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label>
            <input type="number" id="path_y" class="attr_changer" data-title="Change ellipse's cy coordinate" data-attr="y" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
        </div>
      </div>

      <div id="image_panel" class="context_panel clearfix">
        <h4>Image</h4>
        <div class="draginputs">
          <label class="draginput">
            <input type="number" id="image_x" class="attr_changer" data-title="Change X coordinate" data-attr="x" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label class="draginput">
            <input type="number" id="image_y" class="attr_changer" data-title="Change Y coordinate" data-attr="y" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
          <label class="draginput">
            <input type="number" id="image_width" class="attr_changer" data-title="Change image width" data-attr="width" pattern="[0-9]*" min="0" max="10000" />
            <span class="icon_label">Width</span>
          </label>
          <label class="draginput">
            <input type="number" id="image_height" class="attr_changer" data-title="Change image height" data-attr="height" pattern="[0-9]*" min="0" max="10000" />
            <span class="icon_label">Height</span>
          </label>
        </div>
      </div>

      <div id="circle_panel" class="context_panel">
        <h4>Circle</h4>
        <div class="draginputs">
          <label id="tool_circle_cx" class="draginput">
            <span>Center X</span>
            <input type="number" id="circle_cx" class="attr_changer" title="Change circle's cx coordinate" data-attr="cx" min="0" max="10000" />
          </label>
          <label id="tool_circle_cy" class="draginput">
            <span>Center Y</span>
            <input type="number" id="circle_cy" class="attr_changer" title="Change circle's cy coordinate" data-attr="cy" min="0" max="10000" />
          </label>
          <label id="tool_circle_r" class="draginput">
            <span>Radius</span>
            <input type="number" id="circle_r" class="attr_changer" title="Change circle's radius" data-attr="r" min="0" max="10000" />
          </label>
        </div>
      </div>

      <div id="ellipse_panel" class="context_panel">
        <h4>Ellipse</h4>
        <div class="draginputs">
          <label id="tool_ellipse_cx">
            <input type="number" id="ellipse_cx" class="attr_changer" data-title="Change ellipse's cx coordinate" data-attr="cx" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label id="tool_ellipse_cy">
            <input type="number" id="ellipse_cy" class="attr_changer" data-title="Change ellipse's cy coordinate" data-attr="cy" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
          <label id="tool_ellipse_rx">
            <input type="number" id="ellipse_rx" class="attr_changer" data-title="Change ellipse's x radius" data-attr="rx" pattern="[0-9]*" min="0" max="10000" />
            <span>Radius X</span>
          </label>
          <label id="tool_ellipse_ry">
            <input type="number" id="ellipse_ry" class="attr_changer" data-title="Change ellipse's y radius" data-attr="ry" pattern="[0-9]*" min="0" max="10000" />
            <span>Radius Y</span>
          </label>
        </div>
      </div>

      <div id="line_panel" class="context_panel clearfix">
        <h4>Line</h4>
        <div class="draginputs">
          <label id="tool_line_x1">
            <input type="number" id="line_x1" class="attr_changer" data-title="Change line's starting x coordinate" data-attr="x1" pattern="[0-9]*" min="0" max="10000" />
            <span>Start X</span>
          </label>
          <label id="tool_line_y1">
            <input type="number" id="line_y1" class="attr_changer" data-title="Change line's starting y coordinate" data-attr="y1" pattern="[0-9]*" min="0" max="10000" />
            <span>Start Y</span>
          </label>
          <label id="tool_line_x2">
            <input type="number" id="line_x2" class="attr_changer" data-title="Change line's ending x coordinate" data-attr="x2" pattern="[0-9]*" min="0" max="10000" />
            <span>End X</span>
          </label>
          <label id="tool_line_y2">
            <input type="number" id="line_y2" class="attr_changer" data-title="Change line's ending y coordinate" data-attr="y2" pattern="[0-9]*" min="0" max="10000" />
            <span>End Y</span>
          </label>
        </div>
      </div>

      <div id="text_panel" class="context_panel">
        <h4>Text</h4>
        <div class="draginputs">
          <label class="draginput twocol textcontent hidden" data-title="Change Content">
            <input id="text" type="text" autocomplete="off" />
            <span>Content</span>
          </label>
          <label>
            <input type="number" id="text_x" class="attr_changer" data-title="Change text x coordinate" data-attr="x" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label>
            <input type="number" id="text_y" class="attr_changer" data-title="Change text y coordinate" data-attr="y" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
          <div class="toolset draginput twocol" id="tool_font_family">
            <!-- Font family -->
            <span>Font</span>
            <div id="preview_font" style="font-family: sans-serif">sans-serif</div>
            <div class="caret"></div>
            <input id="font_family" data-title="Change Font Family" size="12" type="hidden" />
            <select id="font_family_dropdown"></select>
          </div>
          <div class="draginput font_style">
            <span>Font Style</span>
            <div id="tool_bold" data-title="Bold Text">B</div>
            <div id="tool_italic" data-title="Italic Text">i</div>
          </div>
          <label id="tool_font_size" data-title="Change Font Size">
            <input type="number" id="font_size" value="0" min="0" max="10000" />
            <span id="font_sizeLabel" class="icon_label">Font Size</span>
          </label>
        </div>
      </div>

      <!-- formerly gsvg_panel -->
      <div id="svg_panel" class="context_panel clearfix">
        <h4>SVG</h4>
      </div>

      <div id="use_panel" class="context_panel clearfix">
        <h4>Use</h4>
        <div class="button full" id="tool_unlink_use" data-title="Break link">Break use ref</div>
      </div>

      <div id="g_panel" class="context_panel clearfix">
        <h4>Group</h4>
        <div class="draginputs">
          <label>
            <input type="number" id="g_x" class="attr_changer" data-title="Change groups's x coordinate" data-attr="x" pattern="[0-9]*" min="0" max="10000" />
            <span>X</span>
          </label>
          <label>
            <input type="number" id="g_y" class="attr_changer" data-title="Change groups's y coordinate" data-attr="y" pattern="[0-9]*" min="0" max="10000" />
            <span>Y</span>
          </label>
        </div>
        <div class="button full" title="Ungroup Elements" id="button_ungroup">Ungroup</div>
      </div>

      <div id="path_node_panel" class="context_panel clearfix">
        <h4>Edit Path</h4>

        <div class="draginputs">
          <label id="tool_node_x">
            <input type="number" id="path_node_x" class="attr_changer" data-title="Change node's x coordinate" data-attr="x" min="0" max="10000" />
            <span>X</span>
          </label>
          <label id="tool_node_y">
            <input type="number" id="path_node_y" class="attr_changer" data-title="Change node's y coordinate" data-attr="y" min="0" max="10000" />
            <span>Y</span>
          </label>

          <div id="segment_type" class="draginput label">
            <span>Seg Type</span>
            <select id="seg_type" data-title="Change Segment type">
              <option id="straight_segments" selected="selected" value="4">Straight</option>
              <option id="curve_segments" value="6">Curve</option>
            </select>
            <div class="caret"></div>
            <label id="seg_type_label">Straight</label>
          </div>
        </div>

        <div class="button-container clearfix">
          <div class="button full" id="tool_node_clone" title="Adds a node">Add Node</div>
          <div class="button full" id="tool_node_delete" title="Delete Node">Delete Node</div>
          <div class="button full" id="tool_openclose_path" title="Open/close sub-path">Open/close Path</div>
        </div>
      </div>

      <!-- Buttons when a single element is selected -->
      <div id="selected_panel" class="context_panel">
        <div class="draginputs">
          <label id="tool_angle" data-title="Change rotation angle" class="draginput">
            <input id="angle" class="attr_changer" size="2" value="0" data-attr="transform" data-min="-180" data-max="180" type="number" />
            <span class="icon_label">Rotation</span>
            <div id="tool_angle_indicator" class="angle">
              <div id="tool_angle_indicator_cursor" class="angle-cursor"></div>
            </div>
          </label>

          <label id="tool_opacity" data-title="Change selected item opacity">
            <input type="number" id="group_opacity" class="attr_changer" data-attr="opacity" value="100" step="5" min="0" max="100" />
            <span id="group_opacityLabel" class="icon_label">Opacity</span>
          </label>

          <label id="tool_blur" data-title="Change gaussian blur value">
            <input type="number" id="blur" size="2" value="0" step=".1" min="0" max="10" />
            <span class="icon_label">Blur</span>
          </label>

          <label id="cornerRadiusLabel" data-title="Change Rectangle Corner Radius">
            <input id="rect_rx" value="0" data-attr="rx" class="attr_changer" type="number" pattern="[0-9]*" min="0" max="90" />
            <span class="icon_label">Roundness</span>
          </label>
        </div>

        <div id="align_tools">
          <h4>Align to canvas</h4>
          <div class="toolset align_buttons" id="tool_position">
            <label>
              <div class="col last clear" id="position_opts">
                <div class="align_button" id="tool_posleft" title="Align Left" data-align="left">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 2 1 L 2 5 L 14 5 L 14 11 L 2 11 L 2 16 L 20 16 L 20 22 L 2 22 L 2 26 L 1 26 L 1 1 L 2 1 Z" />
                  </svg>
                </div>
                <div class="align_button" id="tool_poscenter" title="Align Center" data-align="center">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 13 1 L 14 1 L 14 6 L 22 6 L 22 12 L 14 12 L 14 15 L 19 15 L 19 21 L 14 21 L 14 26 L 13 26 L 13 21 L 8 21 L 8 15 L 13 15 L 13 12 L 5 12 L 5 6 L 13 6 L 13 1 Z" />
                  </svg>
                </div>
                <div class="align_button" id="tool_posright" title="Align Right" data-align="right">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 25 1 L 25 5 L 13 5 L 13 11 L 25 11 L 25 16 L 7 16 L 7 22 L 25 22 L 25 26 L 26 26 L 26 1 L 25 1 Z" />
                  </svg>
                </div>
                <div class="align_button" id="tool_postop" title="Align Top" data-align="top">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 1 2 L 5 2 L 5 14 L 11 14 L 11 2 L 16 2 L 16 20 L 22 20 L 22 2 L 26 2 L 26 1 L 1 1 L 1 2 Z" />
                  </svg>
                </div>
                <div class="align_button" id="tool_posmiddle" title="Align Middle" data-align="middle">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 26 13 L 26 14 L 21 14 L 21 22 L 15 22 L 15 14 L 12 14 L 12 19 L 6 19 L 6 14 L 1 14 L 1 13 L 6 13 L 6 8 L 12 8 L 12 13 L 15 13 L 15 5 L 21 5 L 21 13 L 26 13 Z" />
                  </svg>
                </div>
                <div class="align_button" id="tool_posbottom" title="Align Bottom" data-align="bottom">
                  <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                    <path d="M 1 25 L 5 25 L 5 13 L 11 13 L 11 25 L 16 25 L 16 7 L 22 7 L 22 25 L 26 25 L 26 26 L 1 26 L 1 25" />
                  </svg>
                </div>
              </div>
              <div class="clearfix"></div>
            </label>
          </div>
        </div>
      </div>

      <!-- Buttons when multiple elements are selected -->
      <div id="multiselected_panel" class="context_panel clearfix">
        <h4 class="hidable">Multiple Elements</h4>

        <div class="toolset align_buttons">
          <label id="tool_align_relative">
            <div class="select-input">
              <select id="align_relative_to" title="Align relative to ..." class="select_tool">
                <option id="selected_objects" value="selected">Align to objects</option>
                <option id="page" value="page">Align to page</option>
              </select>
            </div>
          </label>
          <div class="col last clear">
            <div class="align_button" id="tool_alignleft" title="Align Left" data-align="left">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 2 1 L 2 5 L 14 5 L 14 11 L 2 11 L 2 16 L 20 16 L 20 22 L 2 22 L 2 26 L 1 26 L 1 1 L 2 1 Z" />
              </svg>
            </div>
            <div class="align_button" id="tool_aligncenter" title="Align Center" data-align="center">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 13 1 L 14 1 L 14 6 L 22 6 L 22 12 L 14 12 L 14 15 L 19 15 L 19 21 L 14 21 L 14 26 L 13 26 L 13 21 L 8 21 L 8 15 L 13 15 L 13 12 L 5 12 L 5 6 L 13 6 L 13 1 Z" />
              </svg>
            </div>
            <div class="align_button" id="tool_alignright" title="Align Right" data-align="right">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 25 1 L 25 5 L 13 5 L 13 11 L 25 11 L 25 16 L 7 16 L 7 22 L 25 22 L 25 26 L 26 26 L 26 1 L 25 1 Z" />
              </svg>
            </div>
            <div class="align_button" id="tool_aligntop" title="Align Top" data-align="top">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 1 2 L 5 2 L 5 14 L 11 14 L 11 2 L 16 2 L 16 20 L 22 20 L 22 2 L 26 2 L 26 1 L 1 1 L 1 2 Z" />
              </svg>
            </div>
            <div class="align_button" id="tool_alignmiddle" title="Align Middle" data-align="middle">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 26 13 L 26 14 L 21 14 L 21 22 L 15 22 L 15 14 L 12 14 L 12 19 L 6 19 L 6 14 L 1 14 L 1 13 L 6 13 L 6 8 L 12 8 L 12 13 L 15 13 L 15 5 L 21 5 L 21 13 L 26 13 Z" />
              </svg>
            </div>
            <div class="align_button" id="tool_alignbottom" title="Align Bottom" data-align="bottom">
              <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="27" height="27">
                <path d="M 1 25 L 5 25 L 5 13 L 11 13 L 11 25 L 16 25 L 16 7 L 22 7 L 22 25 L 26 25 L 26 26 L 1 26 L 1 25" />
              </svg>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="button full" id="button_group">Group Elements</div>
        <div class="button full" id="tool_text_on_path" title="Place text on path">Place text on path</div>
      </div>

      <div id="stroke_panel" class="context_panel">
        <h4>Stroke</h4>
        <div class="draginputs">
          <label class="draginput" data-title="Change stroke">
            <input type="number" id="stroke_width" size="2" value="1" data-attr="stroke-width" min="0" max="99" step="1" />
            <span class="icon_label">Width</span>
          </label>
          <div class="stroke_tool draginput">
            <span>Dash</span>
            <select id="stroke_style" data-title="Change stroke dash style">
              <option selected="selected" value="none">—</option>
              <option value="2,2">···</option>
              <option value="5,5">- -</option>
              <option value="5,2,2,2">-·-</option>
              <option value="5,2,2,2,2,2">-··-</option>
            </select>
            <div class="caret"></div>
            <label id="stroke_style_label">—</label>
          </div>

          <label style="display: none">
            <span class="icon_label">Stroke Join</span>
          </label>

          <label style="display: none">
            <span class="icon_label">Stroke Cap</span>
          </label>
        </div>
      </div>
    </div>
    <!-- tools_top -->
    <div id="cur_context_panel"></div>

    <div id="tools_left" class="tools_panel">
      <div class="tool_button" id="tool_select" data-mode="select" title="Select Tool">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path d="M17.15 20.76l-2.94 1.5-3.68-6-4.41 3V1.24l12.5 12.01-4.41 1.5 2.94 6z" />
        </svg>
      </div>
      <div class="tool_button" id="tool_line" data-mode="line" title="Line Tool">
        <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="M 3 1 L 26 24 L 24 26 L 1 3 L 3 1 Z"></path>
        </svg>
      </div>
      <div class="tool_button" id="tool_rect" data-mode="rect" title="Square/Rect Tool">
        <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="M 0 8 L 0 24 L 24 24 L 25 8 L 0 8 Z" />
        </svg>
      </div>
      <div class="tool_button" id="tool_ellipse" data-mode="ellipse" title="Ellipse/Circle Tool">
        <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <ellipse cx="13" cy="13" rx="13" ry="9"></ellipse>
        </svg>
      </div>

      <div class="tool_button" id="tool_shapelib" data-mode="shapelib" title="Approbations">
        <svg xmlns="http://www.w3.org/2000/svg" height="27" width="27" viewBox="0 0 24 24">
          <image
            height="30"
            width="30"
            href="data:image/svg+xml;base64,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"
          ></image>
        </svg>
        <div class="tool_menu"></div>
      </div>
      <div class="tool_button" id="tool_text" data-mode="text" title="Text Tool">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="2 2 20 20" width="27" height="27">
          <path d="M5 4v3h5.5v12h3V7H19V4z" />
        </svg>
      </div>
      <div class="tool_button" id="tool_barcode" data-mode="barcode" title="Barcode Tool">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 512 512" width="27">
          <path
            d="M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24L64 56c0-13.3-10.7-24-24-24L24 32zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zm96 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zM448 56l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
          />
        </svg>
      </div>

      <div id="color_tools" style="visibility: hidden">
        <div id="tool_switch" title="Switch stroke and fill colors">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
            <path d="M3.01 2A6 6 0 019 8h1.83l-2.91 2.91L5 8h2a4 4 0 00-3.99-4v1.93L.1 3.02 3.01.1V2z" />
          </svg>
        </div>
        <div class="color_tool active" id="tool_fill">
          <label class="icon_label" title="Change fill color"></label>
          <div class="color_block">
            <div id="fill_bg"></div>
            <div id="fill_color" class="color_block"></div>
          </div>
        </div>

        <div class="color_tool" id="tool_stroke">
          <label class="icon_label" title="Change stroke color"></label>
          <div class="color_block">
            <div id="stroke_bg"></div>
            <div id="stroke_color" class="color_block" title="Change stroke color"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- tools_left -->

    <div id="tools_bottom" class="tools_panel">
      <!-- Zoom buttons -->
      <select id="zoom_select">
        <option value="6">6%</option>
        <option value="12">12%</option>
        <option value="16">16%</option>
        <option value="25">25%</option>
        <option value="50">50%</option>
        <option value="75">75%</option>
        <option value="100" selected="selected">100%</option>
        <option value="150">150%</option>
        <option value="200">200%</option>
        <option value="300">300%</option>
        <option value="400">400%</option>
        <option value="600">600%</option>
        <option value="800">800%</option>
        <option value="1600">1600%</option>
      </select>
      <div id="zoom_panel" class="toolset" title="Change zoom level">
        <div class="select-input" id="zoom_label">
          <span id="zoomLabel" class="zoom_tool icon_label">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="2 2 20 20" width="27">
              <path
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
            </svg>
          </span>
          <input id="zoom" value="100%" type="text" readonly="readonly" />
        </div>
      </div>
    </div>

    <!-- hidden divs -->
    <div id="color_picker"></div>
  </div>
  <!-- /app -->

  <div id="dialog_box">
    <div id="dialog_box_overlay"></div>
    <div id="dialog_container">
      <div id="dialog_content"></div>
      <div id="dialog_buttons"></div>
    </div>
  </div>

  <ul id="cmenu_canvas" class="contextMenu">
    <li>
      <a href="#cut" onclick="return false;">Cut <span class="shortcut">⌘X;</span></a>
    </li>
    <li>
      <a href="#copy" onclick="return false;">Copy<span class="shortcut">⌘C</span></a>
    </li>
    <li>
      <a href="#paste" onclick="return false;">Paste<span class="shortcut">⌘V</span></a>
    </li>
    <li class="separator">
      <a href="#delete" onclick="return false;">Delete<span class="shortcut">⌫</span></a>
    </li>
    <li class="separator">
      <a href="#group" onclick="return false;">Group</a>
    </li>
    <li>
      <a href="#ungroup" onclick="return false;">Ungroup</a>
    </li>
    <li class="separator">
      <a href="#move_front" onclick="return false;">Bring to Front</a>
    </li>
    <li>
      <a href="#move_up" onclick="return false;">Bring Forward</a>
    </li>
    <li>
      <a href="#move_down" onclick="return false;">Send Backward</a>
    </li>
    <li>
      <a href="#move_back" onclick="return false;">Send to Back</a>
    </li>
  </ul>

  <div class="tools_flyout inverted-undo" id="tools_shapelib">
    <div id="shape_buttons"></div>
  </div>
</div>
